import qrcode from "qrcode-generator";

/** Builds a self-contained QR image so joining never depends on a third-party service. */
export function joinQrDataUrl(joinUrl: string): string {
  const code = qrcode(0, "M");
  code.addData(joinUrl, "Byte");
  code.make();
  return code.createDataURL(6, 24);
}
